const Vuex = require("vuex");
const Cookies = require("js-cookie");
const menuUtil = require("../utils/index").default;
const router = require("../router/router").default;
const hump = require("../utils/humpToLine");
import Message from "@/utils/message";
import i18n from "../utils/i18n";
export default new Vuex.Store({
  state: {
    menuList: [],
    initFlag: true,
    collapse: false,
    tagsTop: true,
    innerHeight: window.innerHeight,
    tagList: [],
    visitedViews: [],
    permissions: [],
    roles: [],
    avatar: "",
    nickName: "",
    machineInfo: {
      about: 0,
      expired: 0
    },
    isDot: false,
    langList: []
  },
  mutations: {
    set(state, payload) {
      for (let i in payload) {
        state[i] = payload[i];
      }
    },
    updateLangList(state, data) {
      state.langList = data;
    },
    LOGIN(state, user) {
      Cookies.set("token", user.token, { expires: 7 });
      Cookies.set("nickName", user.nickName, { expires: 7 });
      Cookies.set("uid", user.uid, { expires: 7 });
      Cookies.set("checked", user.checked, { expires: 7 });
      Cookies.set("userName", user.userName, { expires: 7 });
      Cookies.set("zone", user.timeZone, { expires: 7 });
      console.log(user, 111);
      state.permissions = user.authority;
      if (user.menu && user.menu.length > 0) {
        let fmRoutes = menuUtil.formatRoutes(user.menu);
        router.addRoutes(fmRoutes);
        state.menuList = user.menu;
      } else {
        Message.warning({
          message: i18n.t("api.np"),
          duration: 2000,
          showClose: false
        });
        this.$router.push("/login");
      }
    },
    LOGIN_OUT(state) {
      Cookies.remove("token");
      Cookies.remove("avatar");
      Cookies.remove("nickName");
      Cookies.remove("uid");
      Cookies.remove("checked");
      Cookies.remove("userType");
      Cookies.remove("userName");
      state.tagList = [];
      state.menuList = [];
      state.visitedViews = [];
      // window.location.reload()
    },
    INIT_FLAG(state, initFlag) {
      state.initFlag = initFlag;
    },
    INIT_MENU_LIST(state, menuAuth) {
      if (menuAuth.menu && menuAuth.menu.length > 0) {
        state.menuList = menuAuth.menu;
      }
      if (menuAuth.authority && menuAuth.authority.length > 0) {
        state.permissions = menuAuth.authority;
      }
    },
    COLLAPSE(state, collapse) {
      state.collapse = collapse;
    },
    TAGS_TOP(state, tagsTop) {
      state.tagsTop = tagsTop;
    },
    INNER_HEIGHT(state, height) {
      state.innerHeight = height;
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.fullPath)) {
        return;
      }
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.meta.title || "not name"
      });
      if (view.meta.keepAlive === "0") {
        let path = view.path.split("/");
        state.tagList.push(hump.default.toHump(path[path.length - 1]));
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1);
          state.tagList.splice(i, 1);
          break;
        }
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      state.visitedViews = state.visitedViews.filter(item => {
        return item.path === view.fullPath;
      });
      state.tagList = state.tagList.filter(item => {
        let path = view.path.split("/");
        return item === hump.default.toHump(path[path.length - 1]);
      });
    },
    DEL_ALL_VIEWS: state => {
      state.visitedViews = [];
      state.tagList = [];
    },
    UPDATE_USER: (state, user) => {
      state.nickName = user.nickName;
    },
    UPDATE_AVATAR: (state, avatar) => {
      state.avatar = avatar;
      let userAvatar = Cookies.get("avatar");
      if (!userAvatar) {
        Cookies.set("avatar", avatar, { expires: 7 });
      }
    },
    MACHINE_INFO: (state, info) => {
      state.machineInfo.about = info.aboutCount;
      state.machineInfo.expired = info.expiredCount;
      if (info.expiredCount > 0 || info.aboutCount > 0) {
        state.isDot = true;
      }
    }
  },
  /*异步的去commit操作*/
  actions: {
    login({ commit }, user) {
      commit("LOGIN", user);
    },
    loginOut({ commit }) {
      commit("LOGIN_OUT");
    },
    initMenuList({ commit }, menuList) {
      commit("INIT_MENU_LIST", menuList);
    },
    initFlag({ commit }, flag) {
      commit("INIT_FLAG", flag);
    },
    collapse({ commit }, collapse) {
      commit("COLLAPSE", collapse);
    },
    tagsTop({ commit }, tagsTop) {
      commit("TAGS_TOP", tagsTop);
    },
    innerHeight({ commit }, height) {
      commit("INNER_HEIGHT", height);
    },
    addVisitedViews({ commit }, view) {
      commit("ADD_VISITED_VIEWS", view);
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit("DEL_VISITED_VIEWS", view);
        resolve([...state.visitedViews]);
      });
    },
    delOthersViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit("DEL_OTHERS_VIEWS", view);
        resolve([...state.visitedViews]);
      });
    },
    delAllViews({ commit, state }) {
      return new Promise(resolve => {
        commit("DEL_ALL_VIEWS");
        resolve([...state.visitedViews]);
      });
    },
    updateUser({ commit }, user) {
      commit("UPDATE_USER", user);
    },
    updateAvatar({ commit }, avatar) {
      commit("UPDATE_AVATAR", avatar);
    },
    machineInfo({ commit }, info) {
      commit("MACHINE_INFO", info);
    }
  }
});
